module.exports = __webpack_public_path__ + "static/media/ieee-sha.ebcaa567.png";